var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error404"},[_c('div',[_c('h3',[_vm._v("404!页面找不到")]),_c('p',{staticClass:"back"},[_c('span',[_vm._v("返回")]),_c('span',{on:{"click":_vm.toHome}},[_vm._v(" 首页 ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }